export default __webpack_public_path__ + "static/media/mannual_img.48700e75.png";